import { formatCompact } from "../utils/formatCompact";

export const ROLE_META = {
  user: { short: "User", tone: "user" },
  agent: { short: "Agent", tone: "staff" },
  ambassador: { short: "Ambassador", tone: "staff" },
  partner: { short: "Partner", tone: "staff" },
  admin: { short: "Admin", tone: "staff" },
  super_admin: { short: "Super", tone: "staff" },
};

export function userInitials(name, email) {
  const src = String(name || email || "?").trim();
  const parts = src.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return src.slice(0, 2).toUpperCase();
}

export function userHeat(user, maxCash) {
  if (user?.isBanned) return 100;
  const cash = Number(user?.CASH) || 0;
  if (!maxCash) return 12;
  return Math.max(8, Math.round((cash / maxCash) * 100));
}

export function userContextLine(user) {
  const parts = [];
  const email = user?.email;
  const invite = user?.inviteCode;

  if (email) parts.push(email);
  if (invite) parts.push(`#${invite}`);

  return parts.join(" · ") || "No contact on file";
}

/** Compact ledger subline (contact + level + cash). */
export function userLedgerSubline(user, formatCompactFn = formatCompact) {
  const parts = [];
  if (user?.email) parts.push(user.email);
  if (user?.inviteCode) parts.push(`#${user.inviteCode}`);
  if (user?.userLevel) parts.push(user.userLevel);
  const cash = Math.max(0, Number(user?.CASH) || 0);
  parts.push(`${formatCompactFn(cash)} cash`);
  return parts.length ? parts.join(" · ") : "No contact on file";
}

export function walletSplit(user) {
  const cash = Math.max(0, Number(user?.CASH) || 0);
  const coin = Math.max(0, Number(user?.COIN) || 0);
  const total = cash + coin;
  if (total <= 0) return { cash, coin, cashFlex: 50, coinFlex: 50 };
  const cashFlex = Math.round((cash / total) * 100);
  return { cash, coin, cashFlex, coinFlex: Math.max(0, 100 - cashFlex) };
}

export { formatCompact };
